import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookIcon,
} from "react-share";
import ReactStars from "react-rating-stars-component";
import ProductImagesSlider from "./productSlider/productSlider";
import { IoArrowBack } from 'react-icons/io5';   // ya FiArrowLeft from 'react-icons/fi' — dono acha lagta hai
import ScrollToTop from "../pages/scroll_to_top";
import Demoimg from "../../assets/images/placeholder.gif";
import Collection3 from "../layouts/tradnity/collection3";
import Heart from "react-heart";
import Loader from "../../svg_code/loader";
import LoaderSpinner from "../../components/loadingspin"

import React, { useEffect, useRef, useState } from "react";
import Service from "./common/service";
import store from "../../store";
import { FiShoppingCart, FiMinus, FiPlus, FiShoppingBag, FiZap, FiHeart, FiShare2, FiCheck, FiCopy } from "react-icons/fi";
import { FaWhatsapp, FaFacebookF } from "react-icons/fa";
import DetailsTopTabs from "./common/details-top-tabs";
import {
  removeWishlist,
  addItemToCart,
  fetchReviews,
} from "../../actions";
import _ from "lodash";
import PeopleViewed from "../layouts/tradnity/peopleViewed";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button } from "antd";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { connect } from "react-redux";
import history from "../../history";
import Placeholder from "../../svg_code/placeholder";
import HeadSEO from "../layouts/tradnity/headSEO";
import "./productDetails.css";
import "../../assets/css/custom.css";

const ProductDetailsMe = (props) => {
  let {
    item,
    pathName,
    shortView,
    currencies,
    appconfigs,
    CutLoading,
    // LoadingSSS,
    contactDetails,
  } = props;
  const myurl = window.location.href;
  const modalRef = useRef();
  const initialState = [];
  const locaaaa = useLocation();
  const queryParams = new URLSearchParams(locaaaa.search);
  const [LoadingSSS, setLoadingSSSS] = useState(false);
  const [gData, setGData] = useState(initialState);
  async function minFunc() {
    for (let va = 0; va < item?.api?.grouped_products.length; va++) {
      await initialState.push({
        id: item?.api?.grouped_products[va].id,
        qty: Number(item?.api?.grouped_products[va].qty),
        url_key: item?.api?.grouped_products[va]?.parent?.url_key
          ? item?.api?.grouped_products[va]?.parent?.url_key
          : item?.api?.grouped_products[va].url_key,
        name: item?.api?.grouped_products[va].name,
      });
    }
  }
  if (item?.api?.grouped_products && item?.api?.grouped_products.length !== 0) {
    minFunc();
  }

  const DeductGQty = (pid) => {
    // 👇️ passing function to setGData method
    setGData((prevState) => {
      const newState = prevState.map((obj) => {
        if (obj.id === pid) {
          return { ...obj, qty: obj.qty === 0 ? 0 : obj.qty - 1 };
        }
        return obj;
      });

      return newState;
    });
  };

  const AddGQty = (pid) => {
    // 👇️ passing function to setGData method
    setGData((prevState) => {
      const newState = prevState.map((obj) => {
        if (obj.id === pid) {
          return { ...obj, qty: obj.qty + 1 };
        }
        return obj;
      });

      return newState;
    });
  };

  const colorCodes = localStorage.getItem("color_theme");
  let parsedColorCodes = JSON.parse(colorCodes);
  let appconfig =
    parsedColorCodes && parsedColorCodes !== null
      ? parsedColorCodes
      : appconfigs;

  function add_wishlist(e) {
    store.dispatch(removeWishlist(e));
  }
  const [validateC, setValidateC] = useState(false);

  const [myTestArr, setMyTestArr] = useState({});
  let allKeys = Object.keys(myTestArr);

  const [qty, setqty] = useState(1);
  const [wishlisted, setWishlisted] = useState(item.wishlist);
  const [image, setImage] = useState(
    item.api.images ? item.api.images : Demoimg,
  );
  const [name, setname] = useState(item.name);
  const [shortDetails, setshortDetails] = useState(item.shortDetails);
  const [rprice, setRprice] = useState(
    item.api.formated_regular_price ? item.api.formated_regular_price : "",
  );
  const [price, setprice] = useState(item.price);
  const [ratingI, setRatingI] = useState(
    item.api.reviews.average_rating ? item.api.reviews.average_rating : "0.0",
  );
  const [totalI, setTotalI] = useState(
    item.api.reviews.total ? item.api.reviews.total : "0",
  );
  const [p_id, setp_id] = useState(item.id);
  const [sku, setSku] = useState(item?.api?.sku || item?.sku || "");
  const [skuCopied, setSkuCopied] = useState(false);
  const [drop, setDrop] = useState(false);
  const [sp_price, set_sp_price] = useState(0);
  const [ff_price, set_ff_price] = useState(0);
  const shareDropdownRef = useRef();
  const [shareOpen, setShareOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        shareDropdownRef.current &&
        !shareDropdownRef.current.contains(event.target)
      ) {
        setShareOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCopyLink = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(myurl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleCopySku = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const currentSku = sku || item?.api?.sku || item?.sku;
    if (currentSku && navigator.clipboard) {
      navigator.clipboard.writeText(currentSku);
      setSkuCopied(true);
      setTimeout(() => setSkuCopied(false), 1800);
    }
  };

  const handleShareToggle = async () => {
    if (navigator.share && window.innerWidth <= 767) {
      try {
        await navigator.share({
          title: name,
          url: myurl,
        });
        return;
      } catch (err) {
        // fallback to dropdown
      }
    }
    setShareOpen((prev) => !prev);
  };

  const [loadingImg, setLoadingImg] = useState(true);
  const counter = useRef(0);

  const imageLoaded = () => {
    counter.current += 1;
    if (counter.current >= 1) {
      setLoadingImg(false);
    }
  };

  const LoadNow = () => {
    setImage(item.api.images ? item.api.images : "");
    setname(item.name);
    setshortDetails(item.shortDetails);
    setprice(item.price);
    setp_id(item.id);
    setSku(item?.api?.sku || item?.sku || "");
    setRatingI(item.api.reviews.average_rating);
    setLoadingImg(true);
    setTotalI(item.api.reviews.total);
    setRprice(
      item.api.formated_regular_price ? item.api.formated_regular_price : "",
    );
    setGData(initialState);
    store.dispatch(fetchReviews(item?.api.id));
    if (item?.api?.is_variant === 0) {
      setValidateC(false);
    }
  };

  useEffect(() => {
    LoadNow();
  }, [window.location.pathname]);

  const addItemTOCart = async (e) => {
    document.querySelector(".loader-wrapper").style = "display: block";
    var item;
    var groupP;
    let dataaaa;
    if (Array.isArray(gData) && gData.length !== 0) {
      item = { product_id: `${e}`, quantity: qty };
      dataaaa = gData.map(
        (da) => (groupP = { ...groupP, [da.id]: da.qty.toString() }),
      );
    } else {
      item = { product_id: e, quantity: qty };
      await store.dispatch(addItemToCart(item));
      setqty(1);
    }

    // let mostQ = { qty: dataaaa[dataaaa.length - 1] };
    // const children = { ...item, ...mostQ };
    // if (Array.isArray(gData) && gData.length !== 0) {
    //   await store.dispatch(addItemToCart(children));
    // }
    modalRef.current && modalRef.current.setProps({ visible: false });
  };

  const getvariant = async (e, code) => {
    if ((allKeys && allKeys.length !== 0) || code) {
      item &&
        item.api &&
        item.api.variants &&
        item.api.variants
          .filter((item) => {
            if (allKeys.length >= 0 || code) {
              if (allKeys.length === 0) {
                return item[code] == e;
              }
              if (allKeys.length === 1) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] && item[code] == e
                );
              }
              if (allKeys.length === 2) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 3) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 4) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 5) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 6) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 7) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 8) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 9) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 10) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[allKeys[9]] == myTestArr[allKeys[9]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 11) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[allKeys[9]] == myTestArr[allKeys[9]] &&
                  item[allKeys[10]] == myTestArr[allKeys[10]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 12) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[allKeys[9]] == myTestArr[allKeys[9]] &&
                  item[allKeys[10]] == myTestArr[allKeys[10]] &&
                  item[allKeys[11]] == myTestArr[allKeys[11]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 13) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[allKeys[9]] == myTestArr[allKeys[9]] &&
                  item[allKeys[10]] == myTestArr[allKeys[10]] &&
                  item[allKeys[11]] == myTestArr[allKeys[11]] &&
                  item[allKeys[12]] == myTestArr[allKeys[12]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 14) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[allKeys[9]] == myTestArr[allKeys[9]] &&
                  item[allKeys[10]] == myTestArr[allKeys[10]] &&
                  item[allKeys[11]] == myTestArr[allKeys[11]] &&
                  item[allKeys[12]] == myTestArr[allKeys[12]] &&
                  item[allKeys[13]] == myTestArr[allKeys[13]] &&
                  item[code] == e
                );
              }
              if (allKeys.length === 15) {
                if (allKeys.find((keya) => keya == code)) {
                  myTestArr[code] = e;
                }

                return (
                  item[allKeys[0]] == myTestArr[allKeys[0]] &&
                  item[allKeys[1]] == myTestArr[allKeys[1]] &&
                  item[allKeys[2]] == myTestArr[allKeys[2]] &&
                  item[allKeys[3]] == myTestArr[allKeys[3]] &&
                  item[allKeys[4]] == myTestArr[allKeys[4]] &&
                  item[allKeys[5]] == myTestArr[allKeys[5]] &&
                  item[allKeys[6]] == myTestArr[allKeys[6]] &&
                  item[allKeys[7]] == myTestArr[allKeys[7]] &&
                  item[allKeys[8]] == myTestArr[allKeys[8]] &&
                  item[allKeys[9]] == myTestArr[allKeys[9]] &&
                  item[allKeys[10]] == myTestArr[allKeys[10]] &&
                  item[allKeys[11]] == myTestArr[allKeys[11]] &&
                  item[allKeys[12]] == myTestArr[allKeys[12]] &&
                  item[allKeys[13]] == myTestArr[allKeys[13]] &&
                  item[allKeys[14]] == myTestArr[allKeys[14]] &&
                  item[code] == e
                );
              }
            }
          })

          .map((value) => {
            let priceV =
              value &&
              value.price &&
              value.price.substring(0, value.price.length - 2);
            let priceVsp =
              value.special_price !== null
                ? value.special_price.substring(
                  0,
                  value.special_price.length - 2,
                )
                : 0;
            set_ff_price(1);
            setname(value.name);
            setImage(
              value.images && value.images.length !== 0 ? value.images : "",
            );
            setshortDetails(value.short_description);
            setprice(`${currencies.code} ${priceV}`);
            setp_id(value.id);
            set_sp_price(priceVsp);
            // const variantPrices = item.api.active_variant.original.data.variant_prices;
            // const idToFind =  891;

            // const foundObject = Object.values(variantPrices).find(obj => obj.id === idToFind);

            const variantPrices =
              item.api.active_variant.original.data.variant_prices;
            const foundObject = variantPrices?.[value?.id];
            if (
              foundObject?.final_price?.formated_price ==
              foundObject?.regular_price?.formated_price
            ) {
              setprice(foundObject?.final_price?.formated_price);
              set_sp_price(foundObject?.final_price?.formated_price);
              setRprice(0);
              // alert("same priceee")
            } else {
              set_sp_price(foundObject?.final_price?.formated_price);
              setRprice(foundObject?.regular_price?.formated_price);
              // setprice(foundObject.regular_price.formated_price)
            }
          });
    }
  };

  const getFilteredOptionListByFirstSelectedItem = (
    allOptions,
    options,
    selected,
  ) => {
    const firstSelect = allOptions[0];
    const firstSelectedValue = selected[firstSelect?.code];
    const selectedProductIds =
      firstSelect?.options.find((v) => v?.id == firstSelectedValue)?.products ||
      [];

    // If we're rendering the same control, just return all its options
    if (firstSelect?.code === options?.code) {
      return options.options || [];
    }

    // Otherwise, only return those options whose `products` array
    // contains at least one of the selectedProductIds
    if (selectedProductIds.length > 0) {
      return (options.options || []).filter(
        (opt) =>
          Array.isArray(opt.products) &&
          opt.products.some((productId) => {
            return selectedProductIds.includes(productId);
          }),
      );
    }

    // No selected products → empty list
    return [];
  };

  const getNumberFromQuery = (value) => {
    if (!value) return null;
    const num = Number(value);
    return isNaN(num) ? null : num;
  };

  useEffect(() => {
    if (
      /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      setDrop(true);
    }
  }, []);

  document.querySelector(".loader-wrapper").style = "display: none";

  return (
    <>
      <ScrollToTop />

      {!shortView && <HeadSEO title={name} />}
      <div className={!drop && !shortView ? "row px-5 container-custom" : "row mx-0 px-0 container-custom"}>
        {drop ? (
          <div className="col-md-2"></div>
        ) : (
          !shortView && (
            <div className="px-5" style={{ marginTop: 90 }}>
              <Service />
            </div>
          )
        )}

        <div className="img-select row" style={{ marginTop: "3rem" }}>
          <div className="firstDiv col-md-4 col-sm-12">
            {shortView ? (
              <>
                {image && image.length !== 0 && typeof image[0] == "string" ? (
                  <LazyLoadImage
                    src={image && image[0]}
                    style={{
                      width: "100%",
                      height: "auto",
                      border: "1px solid rgb(236 132 95 / 50%)",
                      display: "block",
                    }}
                  />
                ) : image &&
                  image.length !== 0 &&
                  image[0]?.original_image_url ? (
                  <LazyLoadImage
                    src={
                      image &&
                      image.length !== 0 &&
                      image[0]?.original_image_url
                    }
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "1px solid rgb(236 132 95 / 50%)",
                      display: "block",

                    }}
                  />
                ) : (
                  <span
                    style={{
                      width: "100%",
                      border: "1px solid rgb(236 132 95 / 50%)",
                    }}
                  >
                    <Placeholder />
                  </span>
                )}
              </>
            ) : (
              <ProductImagesSlider
                images={image}
                item={item}
                imageLoad={() => imageLoaded()}
                imageStyle={{ width: "100%", height: "100%", objectFit: "cover" }}

              />
            )}

            {/* </div> */}
          </div>
          <div className="product-content col-md-8 col-sm-12 pd-main-details-col">
            {/* ── Header: Title + Action Icons (Share & Wishlist) ── */}
            <div className="pd-header-row">
              <div className="pd-title-wrap">
                <h1 className="pd-title">
                  {name}
                  {item && item.api && item.api.Discount_Percentage ? (
                    <span className="pd-discount-badge">
                      -{item.api.Discount_Percentage}% OFF
                    </span>
                  ) : null}
                </h1>

                {/* ── SKU directly below Heading ── */}
                {(sku || item?.api?.sku || item?.sku) && (
                  <div className="pd-sku-line">
                    <span
                      className="pd-sku-badge"
                      title="Click to copy SKU"
                      onClick={handleCopySku}
                    >
                      <span className="pd-sku-label">SKU:</span>
                      <span className="pd-sku-code">{sku || item?.api?.sku || item?.sku}</span>
                      {skuCopied && <span className="pd-sku-copied">Copied!</span>}
                    </span>
                  </div>
                )}
              </div>

              <div className="pd-header-actions">
                {/* ── Top Share Button & Luxury Dropdown ── */}
                <div className="pd-share-wrapper" ref={shareDropdownRef}>
                  <button
                    type="button"
                    className={`pd-action-btn pd-share-btn-top ${shareOpen ? "active" : ""}`}
                    onClick={handleShareToggle}
                    title="Share this piece"
                    aria-label="Share this piece"
                  >
                    <FiShare2 size={18} />
                  </button>

                  {shareOpen && (
                    <div className="pd-share-dropdown">
                      <div className="pd-share-dropdown-header">Share this piece</div>
                      <div className="pd-share-dropdown-list">
                        <FacebookShareButton
                          url={myurl}
                          quote={name}
                          hashtag={`#${parsedColorCodes?.shop_name || "Shanz"}`}
                          className="pd-share-dropdown-item"
                          onClick={() => setShareOpen(false)}
                        >
                          <div className="pd-share-item-content">
                            <span className="pd-share-item-icon fb">
                              <FaFacebookF size={14} />
                            </span>
                            <span>Facebook</span>
                          </div>
                        </FacebookShareButton>

                        <WhatsappShareButton
                          url={myurl}
                          quote={name}
                          hashtag={`#${parsedColorCodes?.shop_name || "Shanz"}`}
                          className="pd-share-dropdown-item"
                          onClick={() => setShareOpen(false)}
                        >
                          <div className="pd-share-item-content">
                            <span className="pd-share-item-icon wa">
                              <FaWhatsapp size={15} />
                            </span>
                            <span>WhatsApp</span>
                          </div>
                        </WhatsappShareButton>

                        <button
                          type="button"
                          className="pd-share-dropdown-item copy-link"
                          onClick={handleCopyLink}
                        >
                          <div className="pd-share-item-content">
                            <span className="pd-share-item-icon copy">
                              {copied ? <FiCheck size={14} /> : <FiCopy size={14} />}
                            </span>
                            <span>{copied ? "Link Copied!" : "Copy Link"}</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* ── Wishlist Button ── */}
                {appconfig &&
                  appconfig?.navbar_wishlist &&
                  appconfig.navbar_wishlist === 1 ? (
                  <div className="pd-wishlist-wrap">
                    {loadingImg ? (
                      <div className="skeleton-item skeleton-titleHEART"></div>
                    ) : (
                      <button
                        type="button"
                        className={`pd-action-btn pd-wishlist-btn ${wishlisted ? "active" : ""}`}
                        onClick={() => {
                          if (localStorage.getItem("customerData")) {
                            add_wishlist(p_id);
                            setWishlisted(!wishlisted);
                          } else {
                            history.push(`${process.env.PUBLIC_URL}/login`);
                          }
                        }}
                        title={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
                        aria-label="Wishlist"
                      >
                        <FiHeart
                          size={19}
                          style={{
                            fill: wishlisted ? "#e63946" : "none",
                            color: wishlisted ? "#e63946" : "#ffffff",
                          }}
                        />
                      </button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            {/* ── Rating & In Stock Row ── */}
            {loadingImg ? (
              <div className="skeleton-item skeleton-titleS"></div>
            ) : (
              <div className="pd-rating-row">
                <div className="pd-rating-stars">
                  <ReactStars
                    count={5}
                    size={20}
                    isHalf={true}
                    value={Number(ratingI)}
                    edit={false}
                    emptyIcon={<i className="far fa-star"></i>}
                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                    fullIcon={<i className="fa fa-star"></i>}
                    activeColor="#f5b96d"
                  />
                </div>
                <span className="pd-rating-text">
                  {Number(ratingI) > 0 ? ratingI : "5.0"}
                </span>
                <span className="pd-rating-count">
                  ({totalI || 0} {Number(totalI) === 1 ? "review" : "reviews"})
                </span>
                <span className="pd-rating-divider">•</span>
                <span className="pd-stock-badge in-stock">
                  <span className="pd-stock-dot"></span> In Stock
                </span>
              </div>
            )}

            {/* ── Price Row ── */}
            <div className="pd-price-row">
              {loadingImg ? (
                <div className="skeleton-item skeleton-titleP my-1"></div>
              ) : (
                <div className="pd-price-container">
                  <span className="pd-price-label">Price:</span>
                  <span className="pd-current-price">
                    {sp_price !== 0 ? sp_price : price}
                  </span>
                  {rprice && rprice !== "" && rprice !== 0 && (
                    <span className="pd-regular-price">
                      {rprice}
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* ── Category & Description ── */}
            {CutLoading ? null : (
              <>
                {item?.api?.Category && item?.api?.Category.length > 0 && (
                  <div className="pd-meta-item">
                    <span className="pd-meta-label">
                      {item?.api?.Category.length > 1
                        ? "Categories:"
                        : "Category:"}
                    </span>
                    <div className="pd-category-chips">
                      {item?.api?.Category.map((cat, key) => (
                        <span key={key} className="pd-category-chip">
                          {cat.name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                <div className="pd-description-block">
                  <span className="pd-meta-label">Description:</span>
                  {loadingImg ? (
                    <>
                      <div className="skeleton-item skeleton-titleD1 my-1"></div>
                      <div className="skeleton-item skeleton-titleD2 my-1"></div>
                    </>
                  ) : (
                    <div
                      className="pd-description-content"
                      dangerouslySetInnerHTML={{ __html: shortDetails }}
                    />
                  )}
                </div>
              </>
            )}

            {/* ── Grouped Products / Variants / Quantity / Actions ── */}
            {item &&
              item?.api &&
              item?.api?.grouped_products &&
              item?.api?.is_group &&
              item?.api?.is_group === 1 &&
              item?.api?.grouped_products?.length !== 0 ? (
              <>
                <h5 className="h5ian fw-bold">Grouped Products:</h5>
                {gData.length !== 0 &&
                  gData.map((e) => (
                    <div className="row align-items-center my-2" key={e.id}>
                      <div className="col-md-8">
                        <Link to={`${process.env.PUBLIC_URL}/product/${e.url_key}`}>
                          <p style={{ margin: 0, color: "#fff" }}>{e?.name}</p>
                        </Link>
                      </div>
                      <div className="col-md-4">
                        <div className="pd-stepper-container">
                          <button
                            type="button"
                            className="pd-stepper-btn minus"
                            onClick={() => DeductGQty(e.id)}
                            aria-label="Decrease"
                          >
                            <FiMinus size={14} />
                          </button>
                          <span className="pd-stepper-value">{e.qty}</span>
                          <button
                            type="button"
                            className="pd-stepper-btn plus"
                            onClick={() => AddGQty(e.id)}
                            aria-label="Increase"
                          >
                            <FiPlus size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <div>
                {/* Variants (if any) */}
                <div className="row">
                  {item &&
                    item.api &&
                    item.api.active_variant &&
                    item.api.active_variant.original.data &&
                    item.api.active_variant.original.data.attributes &&
                    item.api.active_variant.original.data.attributes.length !== 0 &&
                    !loadingImg ? (
                    item.api.active_variant.original.data.attributes.map(
                      (dat, key) => (
                        <div key={key} className="my-2 col-md-6">
                          <h5 className="pd-meta-label mb-2">{dat.label}:</h5>
                          <select
                            id="cars"
                            className="pd-variant-select"
                            ref={(el) => {
                              if (el && el.value === dat.label) {
                                setValidateC(true);
                              }
                            }}
                            onChange={(e) => {
                              if (e.target.value === dat.label) {
                                setValidateC(true);
                              } else {
                                setValidateC(false);
                              }
                              setMyTestArr(
                                (
                                  item &&
                                  item.api &&
                                  item.api.variants &&
                                  item.api.variants.filter(
                                    (item) => item[dat.code] == e.target.value,
                                  )
                                ).length !== 0
                                  ? { ...myTestArr, [dat.code]: e.target.value }
                                  : _.omit(myTestArr, [dat.code]),
                              );
                              getvariant(e.target.value, dat.code);
                            }}
                            required={true}
                          >
                            <option value={dat.label}>
                              Select {dat.label} Option
                            </option>
                            {dat &&
                              dat.options &&
                              dat.options.length !== 0 &&
                              getFilteredOptionListByFirstSelectedItem(
                                item.api.active_variant.original.data
                                  .attributes,
                                dat,
                                myTestArr,
                              ).map((a, key) => (
                                <option key={key} value={a.id}>
                                  {a.label}
                                </option>
                              ))}
                          </select>
                        </div>
                      ),
                    )
                  ) : null}
                </div>

                {/* ── Modern Quantity Stepper ── */}
                <div className="pd-quantity-section">
                  <span className="pd-meta-label">Quantity:</span>
                  <div className="pd-stepper-container">
                    <button
                      type="button"
                      className="pd-stepper-btn minus"
                      onClick={() => setqty(qty === 1 ? 1 : qty - 1)}
                      disabled={qty <= 1}
                      aria-label="Decrease quantity"
                    >
                      <FiMinus size={14} />
                    </button>
                    <span className="pd-stepper-value">{qty}</span>
                    <button
                      type="button"
                      className="pd-stepper-btn plus"
                      onClick={() => setqty(qty + 1)}
                      aria-label="Increase quantity"
                    >
                      <FiPlus size={14} />
                    </button>
                  </div>
                </div>

                {/* ── Cohesive Action Buttons: Add to Cart & Buy It Now ── */}
                <div className="pd-actions-row">
                  <button
                    disabled={validateC}
                    onClick={() => {
                      appconfig &&
                        appconfig?.navbar_guset &&
                        appconfig.navbar_guset === 1
                        ? addItemTOCart(p_id)
                        : history.push(`${process.env.PUBLIC_URL}/login`);
                    }}
                    type="button"
                    className="pd-btn pd-btn-primary"
                  >
                    <FiShoppingBag size={18} />
                    <span>Add to Cart</span>
                  </button>

                  <Link
                    disabled={validateC}
                    to="/cart-sidebar"
                    onClick={() => {
                      appconfig &&
                        appconfig?.navbar_guset &&
                        appconfig.navbar_guset === 1
                        ? addItemTOCart(p_id)
                        : history.push(`${process.env.PUBLIC_URL}/login`);
                    }}
                    className="pd-btn pd-btn-secondary"
                  >
                    <FiZap size={18} />
                    <span>Buy It Now</span>
                  </Link>
                </div>

                {/* ── WhatsApp Support Assistance Button ── */}
                {contactDetails?.data?.whatsapp_number && !CutLoading && (
                  <div className="pd-whatsapp-section">
                    <a
                      target="_blank"
                      href={`https://api.whatsapp.com/send?phone=${contactDetails?.data?.whatsapp_number}`}
                      rel="nofollow noopener noreferrer"
                      className="pd-whatsapp-btn"
                    >
                      <div className="pd-wa-icon-box">
                        <FaWhatsapp size={22} color="#25D366" />
                      </div>
                      <div className="pd-wa-text-box">
                        <span className="pd-wa-status">
                          <span className="pd-wa-dot"></span> Online Support
                        </span>
                        <span className="pd-wa-title">Need Help? Chat with us on WhatsApp</span>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>

        {!shortView && (
          <div className="pd-details-tabs-wrapper">
            <DetailsTopTabs item={item} />
          </div>
        )}

        {drop && !shortView && (
          <div className="my-4 px-5">
            <Service />
          </div>
        )}

        {!shortView && (
          <div className="pd-related-products-wrapper">
            <Collection3
              pathName={pathName}
              maincompLoading={false}
              clickedReload={true}
              category_Id={locaaaa?.state?.category_ids || item?.category?.[0]?.category_id || ""}
              ProductCategories={item?.category || item?.api?.Category || []}
            />
            <PeopleViewed
              pathName={pathName}
              maincompLoading={false}
              clickedReload={true}
              category_Id={locaaaa?.state?.category_ids || item?.category?.[0]?.category_id || ""}
              ProductCategories={item?.category || item?.api?.Category || []}
            />
          </div>
        )}
      </div>

      {imageLoaded && (
        <img
          src={Demoimg}
          style={{ width: 0, height: 0, display: "none" }}
          alt="Not Imp"
          onLoad={() => imageLoaded()}
        />
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    currencies: state?.user?.currencies ? state?.user?.currencies : "",
    appconfigs: state?.user?.config ? state?.user?.config : "",
    contactDetails: state.contactDetails.contactDetails,
  };
}
export default connect(mapStateToProps)(ProductDetailsMe);
